import { z } from "zod";
import { signupFormSiteTypes } from "../../signup-form";

export const getSignupFormSchema = {
  input: z.object({
    shopifyCustomerId: z.string().nullable(),
    customerHash: z.string(),
    formId: z.string().nullable(),
    isOnMobile: z.boolean(),
    site: z.enum(signupFormSiteTypes).optional(),
    utmParams: z.string(),
    forceId: z.string().optional(),
  }),
  output: z.object({
    form: z.any(), // SignupForm, but making a giant schema for it would cramp my style
    formId: z.string().nullable(),
    skipPhoneSteps: z.boolean(),
    reason: z.string().optional(),
  }),
};
